import { call } from './utils';

export const createUser = async (data, accessToken) =>
  await call({
    url: '/api/user/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateUser = async (data, accessToken) =>
  await call({
    url: '/api/user/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeUser = async (data, accessToken) =>
  await call({
    url: '/api/user/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllUsers = async (data, accessToken) =>
  await call({
    url: '/api/user/find/all',
    method: 'GET',
    token: accessToken
  });
export const findUserById = async (data, accessToken) =>
  await call({
    url: '/api/user/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findUserByName = async (data, accessToken) =>
  await call({
    url: '/api/user/by/name',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
